import {
  MenuIcon
} from "./chunk-3AGD6MKM.js";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger
} from "./chunk-IBYHKJKK.js";
import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/canvas/editor/sidebar/CanvasDropdownMenu.tsx
import { useTheme } from "next-themes";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function CanvasDropdownMenu({ actions, menuContent }) {
  const { theme, setTheme } = useTheme();
  if (!actions) return null;
  return /* @__PURE__ */ jsxs(DropdownMenuContent, { align: "start", children: [
    menuContent,
    actions.onBackToWorkspace && /* @__PURE__ */ jsxs(DropdownMenuItem, { onClick: actions.onBackToWorkspace, children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "arrow-left", className: "h-4 w-4 mr-1" }),
      "Back to Workspace"
    ] }),
    actions.onRename && /* @__PURE__ */ jsxs(DropdownMenuItem, { onClick: actions.onRename, children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "edit", className: "h-4 w-4 mr-1" }),
      "Rename"
    ] }),
    actions.onMoveToProject && /* @__PURE__ */ jsxs(DropdownMenuSub, { children: [
      /* @__PURE__ */ jsx(DropdownMenuSubTrigger, { className: "w-full justify-between", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
        /* @__PURE__ */ jsx(MenuIcon, { name: "folder", className: "h-4 w-4 mr-3" }),
        /* @__PURE__ */ jsx("span", { children: "Move Session" })
      ] }) }),
      /* @__PURE__ */ jsxs(DropdownMenuSubContent, { children: [
        /* @__PURE__ */ jsxs(DropdownMenuItem, { onClick: () => actions.onMoveToProject?.(null), children: [
          /* @__PURE__ */ jsx(MenuIcon, { name: "file", className: "h-4 w-4 mr-2" }),
          "Drafts (no project)"
        ] }),
        actions.availableProjects?.map((project) => /* @__PURE__ */ jsxs(
          DropdownMenuItem,
          {
            onClick: () => actions.onMoveToProject?.(project.uuid),
            children: [
              /* @__PURE__ */ jsx(MenuIcon, { name: "folder", className: "h-4 w-4 mr-2" }),
              project.name
            ]
          },
          project.uuid
        ))
      ] })
    ] }),
    (actions.onBackToWorkspace || actions.onRename || actions.onMoveToProject) && (actions.onDuplicate || actions.onNewCanvas) && /* @__PURE__ */ jsx(DropdownMenuSeparator, {}),
    actions.onDuplicate && /* @__PURE__ */ jsxs(DropdownMenuItem, { onClick: actions.onDuplicate, children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "copy", className: "h-4 w-4 mr-1" }),
      "Duplicate"
    ] }),
    actions.onNewCanvas && /* @__PURE__ */ jsxs(DropdownMenuItem, { onClick: actions.onNewCanvas, children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "plus", className: "h-4 w-4 mr-1" }),
      "New Session"
    ] }),
    (actions.onDuplicate || actions.onNewCanvas || actions.onBackToWorkspace || actions.onRename || actions.onMoveToProject) && (actions.onZoomToFit || actions.onDelete) && /* @__PURE__ */ jsx(DropdownMenuSeparator, {}),
    actions.onZoomToFit && /* @__PURE__ */ jsxs(DropdownMenuItem, { onClick: actions.onZoomToFit, children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "maximize", className: "h-4 w-4 mr-1" }),
      "Zoom to Fit"
    ] }),
    (actions.onZoomIn || actions.onZoomOut || actions.onZoomReset) && /* @__PURE__ */ jsxs("div", { className: "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors", children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "zoom-in", className: "h-4 w-4 mr-3" }),
      /* @__PURE__ */ jsx("span", { className: "flex-1", children: "Zoom" }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: (e) => {
              e.stopPropagation();
              actions.onZoomOut?.();
            },
            className: "flex h-6 w-6 items-center justify-center rounded hover:bg-accent transition-colors",
            title: "Zoom out",
            children: /* @__PURE__ */ jsx(MenuIcon, { name: "minus", className: "h-3 w-3" })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: (e) => {
              e.stopPropagation();
              actions.onZoomReset?.();
            },
            className: "flex h-6 w-[3rem] items-center justify-center rounded hover:bg-accent transition-colors px-2",
            title: "Reset zoom",
            children: /* @__PURE__ */ jsxs("span", { className: "text-xs font-medium", children: [
              actions.currentZoom || 100,
              "%"
            ] })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: (e) => {
              e.stopPropagation();
              actions.onZoomIn?.();
            },
            className: "flex h-6 w-6 items-center justify-center rounded hover:bg-accent transition-colors",
            title: "Zoom in",
            children: /* @__PURE__ */ jsx(MenuIcon, { name: "plus", className: "h-3 w-3" })
          }
        )
      ] })
    ] }),
    (actions.onToggleControls || actions.onToggleMiniMap) && /* @__PURE__ */ jsxs(Fragment, { children: [
      actions.onToggleControls && /* @__PURE__ */ jsxs(
        DropdownMenuItem,
        {
          onClick: (e) => {
            e.preventDefault();
            actions.onToggleControls?.();
          },
          children: [
            /* @__PURE__ */ jsx(MenuIcon, { name: actions.showControls ? "check" : "square", className: "h-4 w-4 mr-1" }),
            "Zoom Controls"
          ]
        }
      ),
      actions.onToggleMiniMap && /* @__PURE__ */ jsxs(
        DropdownMenuItem,
        {
          onClick: (e) => {
            e.preventDefault();
            actions.onToggleMiniMap?.();
          },
          children: [
            /* @__PURE__ */ jsx(MenuIcon, { name: actions.showMiniMap ? "check" : "square", className: "h-4 w-4 mr-1" }),
            "Mini Map"
          ]
        }
      ),
      /* @__PURE__ */ jsx(DropdownMenuSeparator, {})
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors", children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "palette", className: "h-4 w-4 mr-3" }),
      /* @__PURE__ */ jsx("span", { className: "flex-1 mr-8", children: "Theme" }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: (e) => {
              e.stopPropagation();
              setTheme("system");
            },
            className: cn(
              "flex h-6 w-6 items-center justify-center rounded transition-colors",
              theme === "system" ? "bg-accent" : "hover:bg-accent"
            ),
            title: "System theme",
            children: /* @__PURE__ */ jsx(MenuIcon, { name: "monitor", className: "h-3 w-3" })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: (e) => {
              e.stopPropagation();
              setTheme("dark");
            },
            className: cn(
              "flex h-6 w-6 items-center justify-center rounded transition-colors ml-2",
              theme === "dark" ? "bg-accent" : "hover:bg-accent"
            ),
            title: "Dark theme",
            children: /* @__PURE__ */ jsx(MenuIcon, { name: "moon", className: "h-3 w-3" })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: (e) => {
              e.stopPropagation();
              setTheme("light");
            },
            className: cn(
              "flex h-6 w-6 items-center justify-center rounded transition-colors ml-2",
              theme === "light" ? "bg-accent" : "hover:bg-accent"
            ),
            title: "Light theme",
            children: /* @__PURE__ */ jsx(MenuIcon, { name: "sun", className: "h-3 w-3" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs(DropdownMenuItem, { disabled: !actions.onSettings, onClick: actions.onSettings, children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "settings", className: "h-4 w-4 mr-1" }),
      "Settings"
    ] }),
    actions.onDelete && (actions.onBackToWorkspace || actions.onRename || actions.onMoveToProject || actions.onDuplicate || actions.onNewCanvas || actions.onZoomToFit) && /* @__PURE__ */ jsx(DropdownMenuSeparator, {}),
    actions.onDelete && /* @__PURE__ */ jsxs(DropdownMenuItem, { onClick: actions.onDelete, className: "text-destructive", children: [
      /* @__PURE__ */ jsx(MenuIcon, { name: "trash", className: "h-4 w-4 mr-1" }),
      "Delete Session"
    ] })
  ] });
}

export {
  CanvasDropdownMenu
};
//# sourceMappingURL=chunk-EWHVUNGQ.js.map